export default class Filters {
    constructor(filters) {
        Object.assign(this, filters)
        this.$adv = {}
    }

    setAdvFilters(filters) {
        this.$adv = filters
    }

    setFilterOn(filterOn) {
        this.filterOn = filterOn
    }
}